module.exports = __webpack_public_path__ + "static/media/890e536e.jpg";